import styled from '@emotion/styled';
import { Button, FormControl, Grid, Input, InputAdornment, InputLabel, Link, OutlinedInput, Paper, Stack, TextField, Typography } from '@mui/material'
import React from 'react'
import PersonIcon from '@mui/icons-material/Person';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { customStyles } from '../../../styles';
import { MainButton, MainInput, RegularText, SmallText, UnderlineText } from '../../helpers';
import { useDispatch, useSelector } from 'react-redux';
import { loginAction } from '../../../actions';
import { useCustomForm } from '../../../hooks/useCustomForm';
import { useForm } from 'react-hook-form';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useLocalStorage } from '../../../hooks/useLocalStorage';
import { animations } from '../../../utils/animations';
import { setPhone } from '../../../slices/LoginSlice';
import { sendCode } from '../../../actions/loginActions';
import { phone_number } from '../../../utils/supportOptions';
export const LoginForm = () => {
  const { inputValues, handleOnChange, resetForm, setInputValues } = useCustomForm({
    phone: '',
    key: '',
    method: 'password'
  })
  const { user, isLogin } = useSelector(state => state.login)
  const { error, errorContent } = useSelector(state => state.status)
  const { token} = useSelector(state => state.apiToken)
  
  const dispatch = useDispatch()
  const navigate = useNavigate()
  
  const { email, phone, key } = inputValues

  const CustomIcon = styled(WhatsAppIcon)(() => (({
    color: customStyles.colors.secondary,
  }))) 
  const [ authorization, setValue ] = useLocalStorage('login-token', null)

  const handleSubmit = (e) => {
    e.preventDefault()
     dispatch( loginAction(inputValues, token) )
     resetForm(inputValues)
  }

  const handleNavigateCode = () => {
    dispatch(setPhone(phone))
    
    dispatch(sendCode(phone))
    
    navigate('/code')

  }


  useEffect(() => {
    if(authorization?.token) {
      navigate('/dashboard/content')
    }
  }, [authorization?.token])
  
   useEffect(() => {
    user && setValue(user)
   }, [user])

  //  useEffect(() => {
  //   setInputValues({
  //     phone: '',
  //     key: '',
  //     method: 'password'
  //   })
  //  }, [])
  return (
   <Stack width="100%" spacing={2} textAlign="center">
      <MainInput 
        name="phone"
        value={phone}
        onChange={ handleOnChange }
        placeholder="Ingresa tu no. de teléfono o correo electrónico"
        icon={ <PersonIcon /> }
      />
      {/* {
        phone.includes('00X') 
        ? null
        :
        <MainInput 
          name="key"
          value={key}
          onChange={ handleOnChange }
          placeholder="*****"
          type="password"
          icon={ <VisibilityOutlinedIcon /> }
        />
      } */}
      {/* {
        error &&
        <SmallText text={ errorContent } color={ customStyles.colors.red } className={ animations.fadeBottom }/>
      } */}
        <Stack mt={4} mb={2} direction="row" justifyContent="center" spacing={1} alignItems="center" >
        {/* <CustomIcon /> */}
        {/* <SmallText text="¿Necesitas ayuda? Escríbenos" color={ customStyles.colors.main } underline/> */}
        {/* <Button >¿Necesitas ayuda? Escríbenos</Button>
         */}
        <Link href={`https://wa.me/${phone_number}`} target="_blank" underline="hover" variant="body2">
        ¿Necesitas ayuda? Escríbenos
        </Link>
      </Stack>
      <MainButton text="Siguiente" variant="contained" size={ customStyles.buttonSize.full } onClick={ handleNavigateCode }/>
      {/* {
        phone.includes('00x') 
        ? <MainButton text="Siguiente" variant="contained" size={ customStyles.buttonSize.full } onClick={ handleNavigateCode }/>
        : <MainButton text="Siguiente" variant="contained" size={ customStyles.buttonSize.full } onClick={ handleSubmit }/>
        
      } */}
   </Stack>

  )
}
